/**
 * Which selected keywords one "Fetch SERPs" press would search. The server
 * (POST /serps/requests/bulk) decides for real; this only counts for the
 * button, with the same rules: skip a keyword already being searched or
 * searched in the last BULK_FETCH_FRESH_DAYS days, and start at most
 * BULK_FETCH_MAX per press.
 */

export const BULK_FETCH_MAX = 50;
export const BULK_FETCH_FRESH_DAYS = 7;

interface Row {
  keyword_id: number;
  has_pending_serp_request?: boolean;
  latest_serp_date?: string | null;
}

/** Keyword ids worth searching, in list order. */
export function keywordsToFetch(rows: Row[], now: number = Date.now()): number[] {
  const freshSince = now - BULK_FETCH_FRESH_DAYS * 24 * 60 * 60 * 1000;
  const out: number[] = [];
  const seen = new Set<number>();
  for (const r of rows) {
    if (seen.has(r.keyword_id)) continue;
    seen.add(r.keyword_id);
    if (r.has_pending_serp_request) continue;
    const at = r.latest_serp_date ? Date.parse(r.latest_serp_date) : NaN;
    if (!Number.isNaN(at) && at >= freshSince) continue;
    out.push(r.keyword_id);
  }
  return out;
}
